<template>
  <Row>
    <Col :span="onlyLeftPart ? 24 : (formData.leftSpan ? formData.leftSpan : 20)">
      <Form id="queryMain" class="collapse-form" ref="formData" :label-width="data.labelWidth"
            :style="{maxHeight: collapse[collapseType].maxHeight, overflow: collapse[collapseType].overflow}"
            :label-position="data.labelPosition"
            :model="formData">
        <Row v-for="(rowIndex, i) in formData.row" :key="i">
          <Col v-for="(item,index) in formData.items" :key="index" v-if="item.layout.row===rowIndex && (!item.hide || (item.hide && typeof item.hide === 'function' && !item.hide()))"
               :span="item.layout.span" :offset="item.layout.offset" :pull="item.layout.pull" :push="item.layout.push">
            <FormItem :label-width="$t(item.labelWidth) ? $t(item.labelWidth) : 110" :label="item.hideTitle ? '' : $t(item.title)"
                      :required="(item.validators&&item.validators.required)?item.validators.required.required:false"
                      :rules="setRules(item.validators, (item.isDouble || ( item.hide && typeof item.hide === 'function' ? item.hide() : item.hide )))" :prop="'items.' + index + '.value'">
              <template v-if="item.type === 'switch'">
                <m-switch v-model="item.value" @on-change="() => { if (item.change !== undefined) { item.change(item); }}"/>
              </template>
              <template v-if="item.type === 'text'">
                <div v-if="!item.isDouble">
                  <Tooltip :disabled="!item.value">
                    <Input size="small"
                    :icon="item.canClick ? ((item.icon === null || item.icon === '' || item.icon === undefined) ?  'search': item.icon) : ''"
                      @on-click="() => {item.click(item)}"
                      @on-blur="() => { if (item.blur !== undefined) { item.blur(item); }}"
                      @on-focus="() => { if (item.focus !== undefined) { item.focus(item); }}"
                      @on-change="() => { if (item.change !== undefined) { item.change(item); }}" v-model="item.value"
                      :readonly="item.readonly" :type="item.options.rows===1?'text':'textarea'"
                      :rows="item.options.rows" :disabled="item.disabled" :placeholder="$t(item.placeholder)"
                      :style="item.style">
                    </Input>
                    <div slot="content" style="white-space: normal">{{item.value}}</div>
                  </Tooltip>
                </div>
                <div v-else>
                  <Row :gutter="0">
                    <Col span="11">
                      <FormItem :prop="item.field" :rules="setRules(item.validators)">
                        <Tooltip :disabled="!item.value">
                          <Input size="small"
                            :icon="item.canClick ? ((item.icon === null || item.icon === '' || item.icon === undefined) ?  'search': item.icon) : ''"
                            @on-click="() => {item.click(item)}"
                            @on-blur="() => { if (item.blur !== undefined) { item.blur(item); }}"
                            @on-change="() => { if (item.change !== undefined) { item.change(item); }}"
                            v-model="item.value" :readonly="item.readonly"
                            :type="item.options.rows===1?'text':'textarea'" :rows="item.options.rows"
                            :disabled="item.disabled" :placeholder="$t(item.placeholder)" :style="item.style">
                          </Input>
                          <div slot="content" style="white-space: normal">{{item.value}}</div>
                        </Tooltip>
                      </FormItem>
                    </Col>
                    <Col span="2" style="text-align: center">-</Col>
                    <Col span="11">
                      <FormItem :prop="formData.items[index+1].field" :rules="setRules(formData.items[index+1].validators)">
                        <Tooltip :disabled="!formData.items[index+1].value">
                          <Input size="small"
                            :icon="formData.items[index+1].canClick ? ((formData.items[index+1].icon === null || formData.items[index+1].icon === '' || formData.items[index+1].icon === undefined) ?  'search': formData.items[index+1].icon) : ''"
                            @on-click="() => {formData.items[index+1].click(formData.items[index+1])}"
                            @on-blur="() => { if (formData.items[index+1].blur !== undefined) { formData.items[index+1].blur(formData.items[index+1]); }}"
                            @on-change="() => { if (formData.items[index+1].change !== undefined) { formData.items[index+1].change(formData.items[index+1]); }}"
                            v-model="formData.items[index+1].value" :readonly="formData.items[index+1].readonly"
                            :type="formData.items[index+1].options.rows===1?'text':'textarea'"
                            :rows="formData.items[index+1].options.rows" :disabled="formData.items[index+1].disabled"
                            :placeholder="$t(formData.items[index+1].placeholder)"
                            :style="formData.items[index+1].style">
                          </Input>
                          <div slot="content" style="white-space: normal">{{formData.items[index+1].value}}</div>
                        </Tooltip>
                      </FormItem>
                    </Col>
                  </Row>
                </div>
              </template>
              <template v-else-if="item.type === 'number'">
                <Tooltip :disabled="!item.value">
                  <InputNumber v-model="item.value" :readonly="item.readonly" size="small"
                               :max="item.options.max === null ? Infinity : item.options.max"
                               :min="item.options.min === null ? -Infinity : item.options.min" :step="item.options.step"
                               :editable="item.options.editable" :disabled="item.disabled" :style="item.style"
                               :formatter="item.formatter" :parser="item.parser"
                               :precision="item.options.precision"
                               @on-change="() => { if (item.change !== undefined) { item.change(item); }}">
                  </InputNumber>
                  <div slot="content" style="white-space: normal">{{item.value}}</div>
                </Tooltip>
              </template>
              <template v-else-if="item.type === 'radio'">
                <!--<RadioGroup v-model="item.value" :vertical="item.options.vertical" :style="item.style">-->
                <!--<Radio v-for="c in item.options.values" :key="c.value" :disabled="c.disabled" :style="item.options.style">-->
                <!--<span>-->
                <!--{{$t(c.label)}}-->
                <!--</span>-->
                <!--</Radio>-->
                <!--</RadioGroup>-->
                <RadioGroup v-model="item.value" :vertical="item.options.vertical" :style="item.style"
                            @on-change="() => {if (item.change !== undefined) { item.change(item); }}">
                  <Radio v-for="c in item.options.values" :label="$t(c.label)" :key="c.value" :disabled="c.disabled"
                         :style="item.options.style">
                  </Radio>
                </RadioGroup>
              </template>
              <template v-else-if="item.type === 'checkboxGroup'">
                <CheckboxGroup v-model="item.value" :style="item.style">
                  <Checkbox v-for="c in item.options.values" :key="c.value" :value="c.value" :label="c.label"
                            :disabled="item.disabled || c.disabled" :style="item.options.style"></Checkbox>
                </CheckboxGroup>
              </template>
              <template v-else-if="item.type === 'checkbox'">
                <Checkbox v-model="item.value" :disabled="item.disabled" :style="item.style" :true-value="item.trueValue" :false-value="item.falseValue" @on-change="() => { if (item.change !== undefined) { item.change(item); }}">{{item.hideTitle ? item.title : ''}}</Checkbox>
              </template>
              <template v-else-if="item.type ==='datePicker'">
                <div v-if="!item.isDouble">
                  <DatePicker :type="item.options.type" v-model="item.value" :options="item.options.options"
                              :disabled="item.disabled" :format="item.options.format" size="small"
                              :placeholder="$t(item.placeholder)" :style="item.style" :transfer="true"
                              @on-change="() => { if (item.change !== undefined) { item.change(item); }}">
                  </DatePicker>
                </div>
                <div v-else>
                  <Row :gutter="0">
                    <Col span="11">
                      <FormItem :prop="'items.' + index + '.value'" :rules="setRules(item.validators)">
                        <DatePicker :type="item.options.type" v-model="item.value" :options="item.options.options"
                                    :disabled="item.disabled" :format="item.options.format" size="small" :editable="item.editable === false ? false : true"
                                    :placeholder="$t(item.placeholder)" :style="item.style" :transfer="true"
                                    @on-change="(time) => { if (item.change !== undefined) item.change(item, time);}"></DatePicker>
                      </FormItem>
                    </Col>
                    <Col span="2" style="text-align: center">-</Col>
                    <Col span="11">
                      <FormItem :prop="'items.' + (index + 1) + '.value'" :rules="setRules(formData.items[index+1].validators)">
                        <DatePicker :type="formData.items[index+1].options.type" v-model="formData.items[index+1].value"
                                    :options="formData.items[index+1].options.options" size="small"
                                    :disabled="formData.items[index+1].disabled"
                                    :editable="formData.items[index+1].editable === false ? false : true"
                                    :format="formData.items[index+1].options.format"
                                    :placeholder="$t(formData.items[index+1].placeholder)"
                                    :style="formData.items[index+1].style"
                                    :transfer="true"
                                    @on-change="(time) => { if (formData.items[index+1].change !== undefined) formData.items[index+1].change(formData.items[index+1], time);}"></DatePicker>
                      </FormItem>
                    </Col>
                  </Row>
                </div>
              </template>
              <template v-else-if="item.type==='timePicker'">
                <div v-if="!item.isDouble">
                  <TimePicker :type="item.options.type" v-model="item.value" :disabled="item.disabled" size="small"
                              :format="item.options.format" :placeholder="$t(item.placeholder)" :style="item.style" :transfer="true">
                  </TimePicker>
                </div>
                <div v-else>
                  <Row :gutter="0">
                    <Col span="11">
                      <FormItem :prop="item.field">
                        <TimePicker :type="item.options.type" v-model="formData.items[index].value"
                                    :disabled="item.disabled" :format="item.options.format" size="small"
                                    :placeholder="$t(item.placeholder)" :style="item.style" :transfer="true">
                        </TimePicker>
                      </FormItem>
                    </Col>
                    <Col span="2" style="text-align: center">-</Col>
                    <Col span="11">
                      <FormItem :prop="formData.items[index+1].field">
                        <TimePicker :type="formData.items[index+1].options.type" v-model="formData.items[index+1].value"
                                    :disabled="formData.items[index+1].disabled" size="small"
                                    :format="formData.items[index+1].options.format"
                                    :placeholder="$t(formData.items[index+1].placeholder)"
                                    :transfer="true"
                                    :style="formData.items[index+1].style">
                        </TimePicker>
                      </FormItem>
                    </Col>
                  </Row>
                </div>

              </template>
              <template v-else-if="item.type === 'select'">
                <Select :clearable="item.options.clearable === undefined ? true : item.options.clearable"
                        :multiple="item.options.multiple"
                        :disabled="item.disabled || (!item.options.values.length && !item.options.remote)"
                        v-model="item.value" size="small"
                        :label-in-value="item.labelInValue"
                        :transfer="item.options.transfer === undefined? true : item.options.transfer"
                        :filterable="item.filterable"
                        :style="item.style" :placeholder="$t(item.placeholder)"
                        @on-change="handleItemSelectChange(item)"
                        :remote="item.options.remote"
                        :remote-method="(val) => {item.remoteMethod(val)}"
                        :loading="item.loading">
                  <Option v-for="c in item.options.values" :value="c.value" :disabled="c.disabled" :key="c.value">{{$t(c.label)}}</Option>
                </Select>
                <div slot="content" style="white-space: normal">{{item.value}}</div>
              </template>
              <template v-else-if="item.type === 'search'">
                  <Input size="small"
                    icon="search"
                    readonly
                    @on-click="() => {item.click(item)}"
                    @on-blur="() => { if (item.blur !== undefined) { item.blur(item); }}"
                    @on-focus="() => { if (item.focus !== undefined) { item.focus(item); }}"
                    @on-change="() => { if (item.change !== undefined) { item.change(item); }}" v-model="item.value"
                    :rows="item.options.rows"
                    :disabled="item.disabled"
                    :placeholder="$t(item.placeholder)"
                    :style="item.style">
                  </Input>
              </template>
            </FormItem>
          </Col>
        </Row>
      </Form>
    </Col>
    <Col v-if="!onlyLeftPart" :span="formData.leftSpan ? formData.leftSpan : 4" :style="!position ? 'float: right; padding-top: 5px; width: 190px;' : 'padding-top: 5px; width: 180px;position:absolute;right:0;top:0;'">
      <Row type="flex" justify="end" align="middle">
        <Col span="6" style="text-align: center">
          <a class="btn-collapse" href="javascript: void(0)" @click="handleCollapse">
            {{collapse[collapseType].text}}
          </a>
        </Col>
        <Col span="4">
          <a class="btn-collapse" href="javascript: void(0)" @click="handleCollapse">
            <Icon :type="collapse[collapseType].icon"></Icon>
          </a>
        </Col>
        <Col span="14">
          <div class="form-table-btns">
            <Button size="small" type="primary" @click="handleSubmit" :loading="loading" style="width:50px;padding:2px 5px;">
              {{(formData.buttons&&formData.buttons.submitText)?formData.buttons.submitText:$t('common.queryBtn')}}
            </Button>
            <Button v-if="needClear" size="small" type="ghost" @click="handleConfirmReset" style="margin-left: 5px;">
              {{(formData.buttons&&formData.buttons.resetText)?formData.buttons.resetText:$t('common.clearBtn')}}
            </Button>
            <Button v-for="(button, i) in formData.customButtons" :key="i" :type="button.type"
                    @click="button.onClick" style="margin-right: 3px">{{button.label}}
            </Button>
          </div>
        </Col>
      </Row>
    </Col>
    <Modal v-model="showModel" :title="$t('page.query.resetForm')" @on-ok="ok" @on-cancel="cancel">
      <p>{{$t('page.query.confirmReset')}}</p>
    </Modal>
  </Row>
</template>

<script>
  import {formRender as config} from './config.js';
  import {formatDateTime} from '@/utils/datetime-format.js';

  export default {
    name: 'mQuery',
    data() {
      return {
        collapse: {
          up: {
            text: this.$t('common.retract'), // 收起
            icon: 'chevron-up',
            maxHeight: '200px',
            overflow: 'visible'
          },
          down: {
            text: this.$t('common.expand'), // 展开
            icon: 'chevron-down',
            maxHeight: '40px',
            overflow: 'hidden'
          }
        },
        collapseType: 'up',
        showModel: false,
        data: Object.assign({}, this.formData, config.base)
      };
    },
    watch: {
      formData() {
        this.data = Object.assign({}, this.formData, config.base);
      }
    },
    props: {
      loading: {
        type: Boolean,
        default: false
      },
      condition: {
        type: Array,
        default() {
          return [];
        }
      },
      formData: {
        type: Object,
        default() {
          return {
            items: [],
            row: 0
          };
        }
      },
      needValidation: {
        type: Boolean,
        default: false
      },
      onlyLeftPart: {
          type: Boolean,
          default: false
      },
      needClear: {
        type: Boolean,
        default: true
      },
      position: {
        type: Boolean,
        default: false
      }
    },
    methods: {
      handleCollapse() {
        if (this.collapseType === 'up') {
          this.collapseType = 'down';
        } else {
          this.collapseType = 'up';
        }
      },
      ok() {
        this.handleReset('formData');
        this.showModel = false;
      },
      cancel() {
        this.showModel = false;
      },
      /**
       * 表单验证
       * @param name
       * @returns {boolean}
       */
      validateForm() {
        let validate = !this.needValidation; // 默认不用验证表单，配置了true才需要验证
        if (this.needValidation) {
          this.$refs['formData'].validate(valid => {
            if (valid) {
              validate = valid;
            }
          });
        }
        return validate;
      },
        /**
         * 部分表单字段进行校验
         * @param fieldIndex 需要验证的form的下标
         * @returns {boolean}
         */
        validateFieldForm(fieldIndex) {
            let validate = !this.needValidation; // 默认不用验证表单，配置了true才需要验证
            if (this.needValidation) {
                this.$refs['formData'].validateField('items.' + fieldIndex + '.value', (valid) => {
                    if (valid) {
                        validate = valid;
                    }
                });
            }
            return validate;
        },
      /**
       * Select组件选中值改变时触发
       * @param item
       */
      handleItemSelectChange(item) {
        if (item.methods && item.methods.change) {
          item.methods.change(item.value);
        }
      },
      handleSubmit() {
        if (this.validateForm()) {
          // 组装查询条件
          let condition = this.getCondition();
          // 把查询条件通过提交事件发布出去
          this.$emit('onSubmit', condition);
        }
      },
      handleConfirmReset(name) {
        // this.showModel = true;
        this.handleReset('formData');
      },
      handleReset(name) {
        this.$refs[name].resetFields();
        try {
          this.formData.items.map((item) => {
            item.value = item.type === 'number' ? null : '';
          });
        } catch (err) {
          console.log(err);
        }
      },
      // setRules(validators, ignores = []) {
      //   let rules = [];
      //   for (let key in validators) {
      //     if (!ignores.includes(key) && validators.hasOwnProperty(key)) {
      //       rules.push(validators[key]);
      //     }
      //   }
      //   return rules;
      // },
        setRules(validators, canNotSet = false, ignores = []) {
            let rules = [];
            if (canNotSet) {
                return rules;
            }
            for (let key in validators) {
                if (!ignores.includes(key) && validators.hasOwnProperty(key)) {
                    rules.push(validators[key]);
                }
            }
            return rules;
        },
      getCondition() {
        console.log('---time');
        let arr = '{';
        this.formData.items.map(item => {
          // 日期时间格式化
          if (item.type === 'datePicker' || item.type === 'timePicker') {
            console.log('item.type', item.type);
            if (item.options.type === 'daterange' || item.options.type === 'datetimerange') {
              if (item.value.length === 2) {
                item.value[0] = item.value[0] ? formatDateTime(new Date(item.value[0]), item.options.format) : '';
                item.value[1] = item.value[1] ? formatDateTime(new Date(item.value[1]), item.options.format) : '';
              } else {
                // item.value = item.value ? formatDateTime(new Date(item.value), item.options.format) : '';
                item.value = '';
              }
            } else {
                if (item.options.needFormat === false) {
                } else {
                    item.value = item.value ? formatDateTime(new Date(item.value), item.options.format) : '';
                }
            }
          } else {
            try {
              item.value = item.value.replace(/(^\s*)|(\s*$)/g, '');
            } catch (err) {
              console.log(err);
            }
          }
          arr += '"' + item.field + '":"' + item.value + '",';
        });
        arr = arr.substring(0, arr.lastIndexOf(',')) + '}';
        return JSON.parse(arr);
      }
    },
    mounted() {
    }
  };
</script>

<style lang="less" scoped>
  .form-table-btns {
    display: flex;
  }
  .form-table-btns .m-btn {
    /*margin: 0 2px;*/
  }

  #queryMain .m-form-item .m-col-span-11 .m-form-item {
    margin-bottom: 0;
  }

  .collapse-form {
    /*transition: max-height .5s;*/
    /*-moz-transition: max-height .5s; !* Firefox 4 *!*/
    /*-webkit-transition: max-height .5s; !* Safari 和 Chrome *!*/
    /*-o-transition: max-height .5s; !* Opera *!*/
  }

  .btn-collapse {
    display: block;
  }
</style>
